/**
 * Feature flags — centralized so we can toggle experimental / staged
 * capabilities without hunting through every consumer.
 *
 * Each flag defaults to a safe/off value; individual pages import the
 * one they need and branch off it. Keep this file dependency-free.
 */

// Master switch for the "Eventos" (event venues) vertical:
//   - When FALSE:
//       * Business Register + Search + Admin dropdowns hide any category
//         belonging to the `eventos` super-group.
//       * Business dashboards for existing eventos venues render the
//         standard UI (Equipo tab visible, generic tooltips, generic
//         placeholders, generic commission copy).
//       * The eventos-specific commission disclaimer, "Días de margen
//         para firmar el contrato" copy, and "Requiero anticipo para
//         separar la fecha" toggle are all skipped.
//   - When TRUE:
//       * All the eventos-specific UI branches described above kick in.
//
// The category records for `eventos` also carry `hidden_from_picker`
// server-side, so even a stale client cannot register a new eventos
// business while this flag is off.
export const EVENTS_ENABLED = false;

// Convenience helper — checks a business super_group against the master
// switch. Returns `true` only when Events is enabled AND the business is
// tagged as an eventos venue.
export function isEventsCategoryActive(superGroup) {
  return EVENTS_ENABLED && superGroup === 'eventos';
}
